import React from 'react';

// Type definitions
interface LogEntry {
  session_start_time: string;
  session_end_time: string | null;
}

interface Participant {
  display_name?: string;
  student_id: string;
  log?: LogEntry[];
}

interface StudentLogsProps {
  participant: Participant;
}

const StudentLogs: React.FC<StudentLogsProps> = ({ participant }) => {
  return (
    <div style={{ padding: '10px', backgroundColor: '#f1f1f1', borderRadius: '5px' }}>
      <h4>Logs for {participant.display_name || participant.student_id}</h4>
      <ul>
        {participant.log?.map((logEntry, index) => (
          <li key={index}>
            <strong>Start Time:</strong> {new Date(logEntry.session_start_time).toLocaleString()} <br />
            <strong>End Time:</strong> {logEntry.session_end_time ? new Date(logEntry.session_end_time).toLocaleString() : '--'}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default StudentLogs;
